import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { BackendResponse, DateService, HttpService, TranslateService } from 'vas-mobile-api';

import { Delivery, DeliveryPos } from '../models/delivery';
import { Transaction } from '../models/transaction';
import { DataExchangeService } from '../services/dataexchange.service';

@Component({
  selector: 'app-transaction-detail',
  templateUrl: './transaction-detail.component.html',
  styleUrls: ['./transaction-detail.component.css']
})
export class TransactionDetailComponent implements OnInit, OnDestroy {


  private ngUnsubscribe: Subject<void> = new Subject<void>();
  public transaction: Partial<Transaction & Delivery & DeliveryPos> = {};
  public locale: string;

  public transactionTypes: any = {
    OUTG: 'LBLPANEL_VERSAND',
    INCO: 'LBLPANEL_INCOMING',
    RESE: 'LBLPANEL_RESERVATION',
    DELR: 'LABEL_COUNTER_RESERVATION',
    DELO: 'LABEL_COUNTER_SHIPMENT',
    DEBI: 'LABEL_MANUAL_TRANSFER',
    CRED: 'LABEL_MANUAL_TRANSFER',
    PAID: 'LBLPANEL_PAYMENT',
    RETR: 'Return reservation',
    RETO: 'RETO'
  };

  constructor(
    private httpService: HttpService,
    private route: ActivatedRoute,
    private dateService: DateService,
    private router: Router,
    private des: DataExchangeService,
    private translateService: TranslateService) { }

  ngOnInit() {
    this.locale = this.translateService.getLanguage();
    this.route.paramMap.pipe(switchMap((params: ParamMap) => {
      return this.httpService.get<BackendResponse<Transaction>>({
        pathId: 'getTransactionDetail', urlParams:
          {
            transactionId: params.get('transactionId'),
            balanceId: params.get('balanceId')
          }
      });
    })).subscribe((response) => {
      response.data.TRANSACTION_DATE = this.dateService.combineDateAndTime(response.data.TRANSACTION_DATE, response.data.TRANSACTION_TIME);
      this.transaction = response.data;
    });

    this.des.back$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      this.router.navigate(['transactionsList']);
    });

  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public isIncoming() {
    return ['INCO', 'DELR', 'DELO', 'CRED', 'RETR'].findIndex(s => s === this.transaction.TRANSACTION_TYPE) > -1;
  }

}
